import type { TableColumn } from "react-data-table-component";
import Skeleton from "react-loading-skeleton";
import styles from "./TableSkelton.module.scss";
import "react-loading-skeleton/dist/skeleton.css";
import { combineClasses } from "@/lib/utils";

interface TableSkeletonProps<T> {
  columns: TableColumn<T>[];
  sidebarOpen?: boolean;
}

const SKELETON_ROW_COUNT = 10;

const TableSkeleton = <T,>({ columns, sidebarOpen }: TableSkeletonProps<T>) => {
  return (
    <div
      style={{
        width: sidebarOpen ? "calc(100vw - 330px)" : "calc(100vw - 165px)",
      }}
      className={styles.table}
    >
      <div>
        <div className={combineClasses(styles.row, styles.heading)}>
          {columns?.map((column) => (
            <div key={column.name as string} style={{ width: column.width || "100px" }}>
              {column?.name as string}
            </div>
          ))}
        </div>
        {Array.from({ length: SKELETON_ROW_COUNT }, (_, rowIndex) => (
          <div key={rowIndex} className={styles.row}>
            {columns?.map((column) => (
              <div key={column.name as string} style={{ width: column.width || "100px" }}>
                <Skeleton width="calc(100% - 1rem)" height="25px" />
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default TableSkeleton;
